/**
 *  HOW TO USE:
 import MsgBox from './util/msgbox';
 MsgBox({
        content: '',  //提示文案
        tips:'', //小字提示文案
        hasClose: false, //默认没有关闭按钮
        closeFun:null, //点击关闭按钮触发的方法
        btns:[  //msgbox按钮列表，可以多个按钮
            {
                text:'', //按钮文案
                fun:'', //点击按钮触发的方法
                noClose:false, //是否不需要关闭弹窗，默认（false）需要关闭
            }
        ]
    });
 */
import '../css/msgbox';

let msgbox, msgbox_ele, msgbox_body, timer = null;

class MsgBox {
  constructor() {
    !msgbox_ele && this.createEle();
  }

  createEle() {
    msgbox_ele = document.createElement('div');
    msgbox_ele.className = 'msgbox-container';
    msgbox_body = document.createElement('div');
    msgbox_body.className = 'msgbox-body';
    setTimeout(() => {
      msgbox_body.className = 'msgbox-body show';
    }, 50)

    msgbox_ele.appendChild(msgbox_body);
    document.body.appendChild(msgbox_ele);

    this.event();
  }

  init(ctr) {
    if (!ctr)return;
    clearTimeout(timer);
    if (!timer) {
      this.ctr = ctr;
      this.render();
    }
    timer = setTimeout(() => {
      //500ms防连点
      timer = null;
    }, 500);
  }

  render() {
    //渲染dom
    let msgbox_str = '';
    if (this.ctr.content) {
      msgbox_str += `<div class="msgbox-content">${this.ctr.content}${this.ctr.tips ? `<div class="msgbox-tips">${this.ctr.tips}</div>` : ''}</div>`;
    }
    if (this.ctr.btns instanceof Array) {
      let btn_str = '';
      this.ctr.btns.forEach((item, index) => {
        btn_str += `<div class="msgbox-btn" data-index="${index}">${item.text}</div>`;
      });
      msgbox_str += `<div class="msgbox-footer">${btn_str}</div>`;
    }
    if (this.ctr.hasClose) {
      msgbox_str += `<div class="msgbox-close"></div>`;
    }
    msgbox_body.innerHTML = msgbox_str;
    msgbox_ele.setAttribute('data-show', '1');
    setTimeout(() => {
      msgbox_body.className = 'msgbox-body show';
    }, 50)
  }

  event() {
    msgbox_ele.addEventListener('touchmove', e => {
      e.stopPropagation();
      e.preventDefault();
    })
    msgbox_body.addEventListener('click', (e) => {
      switch (e.target.className) {
        case 'msgbox-btn':
          //点击按钮
          let btn = this.ctr.btns[e.target.getAttribute('data-index')];
          btn.fun && btn.fun();
          !btn.noClose && msgbox_ele.setAttribute('data-show', '0');
          if (!btn.noClose) {
            msgbox_body.className = 'msgbox-body';
          }
          break;
        case 'msgbox-close':
          //点击关闭
          this.ctr.closeFun && this.ctr.closeFun();
          msgbox_ele.setAttribute('data-show', '0');
          msgbox_body.className = 'msgbox-body';
          break;
      }
    }, false);
  }
}
export default function (ctr) {
  msgbox = msgbox || new MsgBox();
  msgbox.init(ctr);
}